
import { isHex } from "../common"
import { GetAccountReturnType } from "../types/user-operation-types"
import { AccountSource, isAddress, InvalidAddressError, Hex, hexToSignature, signatureToHex, LocalAccount, Address, CustomSource } from "viem"


// Function to create a LocalAccount from a string address
export function createLocalAccount(
    address: string,
): LocalAccount<string, Address> & CustomSource {
    return {
        address: address as Address,
        publicKey: "0x",
        source: "",
        type: 'local',
        signMessage: undefined,
        signTransaction: undefined,
        signTypedData: undefined
    };
}

/**
 * @description Creates a Local Account from a custom signing implementation.
 *
 * @returns A Local Account.
 */
export function toExtendedLocalAccount<accountSource extends AccountSource>(
    source: accountSource,
): GetAccountReturnType<accountSource> {
    if (typeof source === 'string') {
        if (!isAddress(source, { strict: false }))
            throw new InvalidAddressError({ address: source })
        return {
            address: source,
            type: 'json-rpc',
        } as GetAccountReturnType<accountSource>
    }

    if (!isAddress(source.address, { strict: false }))
        throw new InvalidAddressError({ address: source.address })
    return {
        address: source.address,
        nonceManager: source.nonceManager,
        signMessage: source.signMessage,
        signTransaction: source.signTransaction,
        signTypedData: source.signTypedData,
        source: 'custom',
        type: 'local',
    } as GetAccountReturnType<accountSource>
}


export const fixSignedData = (sig: Hex): Hex => {
    let signature = sig
    if (!isHex(signature)) {
        signature = `0x${signature}`
        if (!isHex(signature)) {
            throw new Error(`Invalid signed data ${sig}`)
        }
    }

    let { r, s, v } = hexToSignature(signature)
    if (v === 0n || v === 1n) v += 27n
    // biome-ignore lint/style/noNonNullAssertion: <explanation>
    const joined = signatureToHex({ r, s, v: v! })
    return joined
}
